/*eslint sort-keys: ["error", "asc", {natural: true}]*/
import Experiment from 'utils/experiments/experiment';

export const VARIANTS = {
  CHECKOUT_REDIRECT: 'LP to booking page',
  CONTROL: 'Control',
  CONTROL1: 'Control 1',
  CONTROL2: 'Control 2',
  SHOWPAGE_REDIRECT: 'LP to showpage',
  TREATMENT: 'Treatment',
};

const BOOSTERS_EXPERIMENT = 'POI Card Booster Experiment';
const LAST_MINUTE_FILTERS_EXPERIMENT = 'Last Minute Filters Experiment';
const LFC_IMPACT = 'LFC Impact';
const LTD_LP_Experiment = 'LTD LP Experiment';
const VIDEO_THUMBNAIL_IN_BANNER = 'MB Banner Video Experiment';
const SEATMAP_EXPERIMENT = 'Venue Seats Page Revamp';
const SUBATTRACTIONS_EXPERIMENT = 'Sub-Attractions Page Revamp';
const PRODUCT_CARD_VIDEO = 'Product Card Video Experiment V1';
const C1_COLLECTION_LTT_BROADWAY_PRODUCT_CARD_CTA_EXPERIMENT = 'DE IT CTA Copy';
const C1_COLLECTION_PRODUCT_CARD_CTA_EXPERIMENT_ENGLISH = 'EN LP CTA Copy v2';
const CRUISES_REVAMP = 'Yarra River - Cruises Revamp Experiment';
const HOHO_REVAMP_PARIS_BARCELONA = 'HOHO Mweb v3';
const DAY_TRIPS_LISTICLE = 'Day Trips Listicle Experiment';
const RANKING_EXPERIMENT_V3_REVENUE = 'Ranking Experiment V3 Revenue';
const MIXPANEL_SESSION_REPLAY = 'Mixpanel Session Replay';
const FLEXIBLE_CANCELLATION_EXPERIMENT = 'Cancellation Insurance v1';
const QNA_EXPERIMENT = 'Q&A Experiment';

export const EXPERIMENT_NAMES: Record<string, string> = {
  BOOSTERS_EXPERIMENT,
  C1_COLLECTION_LTT_BROADWAY_PRODUCT_CARD_CTA_EXPERIMENT,
  C1_COLLECTION_PRODUCT_CARD_CTA_EXPERIMENT_ENGLISH,
  CRUISES_REVAMP,
  DAY_TRIPS_LISTICLE,
  FLEXIBLE_CANCELLATION_EXPERIMENT,
  HOHO_REVAMP_PARIS_BARCELONA,
  LAST_MINUTE_FILTERS_EXPERIMENT,
  LFC_IMPACT,
  LTD_LP_Experiment,
  MIXPANEL_SESSION_REPLAY,
  PRODUCT_CARD_VIDEO,
  QNA_EXPERIMENT,
  RANKING_EXPERIMENT_V3_REVENUE,
  SEATMAP_EXPERIMENT,
  SUBATTRACTIONS_EXPERIMENT,
  VIDEO_THUMBNAIL_IN_BANNER,
};

/**
 * Experiments List
 * Ensure Experiment Variant at index 0 is always Control (Current) Variant.
 */
export const EXPERIMENTS: Record<string, Experiment> = {
  [BOOSTERS_EXPERIMENT]: new Experiment(
    BOOSTERS_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [50, 50]
  ),
  [C1_COLLECTION_LTT_BROADWAY_PRODUCT_CARD_CTA_EXPERIMENT]: new Experiment(
    C1_COLLECTION_LTT_BROADWAY_PRODUCT_CARD_CTA_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [100, 0]
  ),
  [C1_COLLECTION_PRODUCT_CARD_CTA_EXPERIMENT_ENGLISH]: new Experiment(
    C1_COLLECTION_PRODUCT_CARD_CTA_EXPERIMENT_ENGLISH,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [100, 0]
  ),
  [CRUISES_REVAMP]: new Experiment(
    CRUISES_REVAMP,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [50, 50]
  ),
  [DAY_TRIPS_LISTICLE]: new Experiment(
    DAY_TRIPS_LISTICLE,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [100, 0]
  ),
  [FLEXIBLE_CANCELLATION_EXPERIMENT]: new Experiment(
    FLEXIBLE_CANCELLATION_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [50, 50]
  ),
  [HOHO_REVAMP_PARIS_BARCELONA]: new Experiment(
    HOHO_REVAMP_PARIS_BARCELONA,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [0, 100]
  ),
  [LAST_MINUTE_FILTERS_EXPERIMENT]: new Experiment(
    LAST_MINUTE_FILTERS_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [0, 100]
  ),
  [LFC_IMPACT]: new Experiment(
    LFC_IMPACT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [100, 0]
  ),
  [LTD_LP_Experiment]: new Experiment(
    LTD_LP_Experiment,
    [VARIANTS.SHOWPAGE_REDIRECT, VARIANTS.CHECKOUT_REDIRECT],
    [0, 100]
  ),
  [MIXPANEL_SESSION_REPLAY]: new Experiment(
    MIXPANEL_SESSION_REPLAY,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [95, 5]
  ),
  [PRODUCT_CARD_VIDEO]: new Experiment(
    PRODUCT_CARD_VIDEO,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [0, 100]
  ),
  [QNA_EXPERIMENT]: new Experiment(
    QNA_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [80, 20]
  ),
  [RANKING_EXPERIMENT_V3_REVENUE]: new Experiment(
    RANKING_EXPERIMENT_V3_REVENUE,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [50, 50]
  ),
  [SEATMAP_EXPERIMENT]: new Experiment(
    SEATMAP_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [50, 50]
  ),
  [SUBATTRACTIONS_EXPERIMENT]: new Experiment(
    SUBATTRACTIONS_EXPERIMENT,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [100, 0]
  ),
  [VIDEO_THUMBNAIL_IN_BANNER]: new Experiment(
    VIDEO_THUMBNAIL_IN_BANNER,
    [VARIANTS.CONTROL, VARIANTS.TREATMENT],
    [100, 0]
  ),
};
